var _ellipse, _circle, _g, _path, _circle2, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_29003)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#060C23"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_29003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 51.9999,
    r: 52,
    fill: "#243CBB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_29003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.2783,
    cy: 37.9294,
    r: 35.4824,
    fill: "#2E293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0969 14.5506C56.5745 14.8032 59.7328 16.2556 62.1553 18.4939L63.2382 17.3993L61.371 15.5119L63.8143 13.0421C63.9045 12.9508 64.0642 12.9508 64.1544 13.0421L68.4997 17.4344C68.5899 17.5256 68.5899 17.687 68.4997 17.7782L66.0494 20.2481L64.1822 18.3606L63.0993 19.4552C65.5496 22.1566 67.042 25.7631 67.042 29.7134C67.042 33.9093 65.3553 37.7123 62.6343 40.4628C59.9133 43.2133 56.1511 44.9183 52.0002 44.9183C47.8493 44.9183 44.0871 43.2133 41.3661 40.4628C38.6451 37.7123 36.9584 33.9093 36.9584 29.7134C36.9584 25.7561 38.4507 22.1566 40.901 19.4552L39.8182 18.3606L37.951 20.2481L35.5076 17.7782C35.4174 17.687 35.4174 17.5256 35.5076 17.4344L39.8529 13.0421C39.9431 12.9508 40.1028 12.9508 40.193 13.0421L42.6363 15.5119L40.7691 17.3993L41.852 18.4939C44.2745 16.2486 47.4259 14.8032 50.9104 14.5506V11.3511H46.5929V5.64659C46.5929 5.42907 46.7734 5.24664 46.9886 5.24664H57.0326C57.2478 5.24664 57.4283 5.42907 57.4283 5.64659V11.3511H53.1108V14.5506H53.0969ZM61.246 20.3744C58.879 17.9817 55.6097 16.5012 52.0002 16.5012C48.3907 16.5012 45.1213 17.9817 42.7543 20.3744C40.3874 22.767 38.9227 26.0718 38.9227 29.7204C38.9227 33.3691 40.3874 36.6739 42.7543 39.0665C45.1213 41.4592 48.3907 42.9397 52.0002 42.9397C55.6097 42.9397 58.879 41.4592 61.246 39.0665C63.613 36.6739 65.0776 33.3691 65.0776 29.7204C65.0707 26.0648 63.6061 22.767 61.246 20.3744Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9858 29.7141H63.2385C63.2176 23.4478 58.1918 18.3675 51.9858 18.3605V29.7141Z",
    fill: "#22FFAA",
    stroke: "#22FFAA",
    strokeWidth: 0.196539,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8443 87.5777C91.8443 87.8397 91.8403 88.1018 91.8309 88.3625C91.8309 88.3638 91.8309 88.3638 91.8309 88.3638C91.8109 88.9783 91.7681 89.5875 91.6999 90.19C89.9805 98.5711 72.9914 105.151 52.2867 105.151C31.5834 105.151 14.5942 98.5711 12.8749 90.19C12.8067 89.5875 12.7639 88.9783 12.7438 88.3638C12.7438 88.3638 12.7438 88.3638 12.7438 88.3625C12.7345 88.1018 12.7305 87.8397 12.7305 87.5777C12.7305 75.7224 17.537 65.422 25.23 58.2753C25.2327 58.2726 25.234 58.2713 25.2367 58.2687C32.3107 51.7006 41.8248 47.7953 52.2867 47.7953C62.75 47.7953 72.2627 51.7006 79.3367 58.2687C79.3394 58.2713 79.3421 58.2726 79.3434 58.2753C87.0378 65.422 91.8443 75.7224 91.8443 87.5777Z",
    fill: "#F2F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4374 48.5995C54.6068 48.5995 56.3654 46.8469 56.3654 44.685C56.3654 42.523 54.6068 40.7704 52.4374 40.7704C50.2679 40.7704 48.5093 42.523 48.5093 44.685C48.5093 46.8469 50.2679 48.5995 52.4374 48.5995Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2773 46.4496C53.0437 46.4496 53.665 46.977 53.665 47.6275V56.3733C53.665 57.0238 53.0437 57.5512 52.2773 57.5512C51.5109 57.5512 50.8896 57.0238 50.8896 56.3733V47.6275C50.8896 46.977 51.5109 46.4496 52.2773 46.4496Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.278 45.3019C53.0448 45.3019 53.6664 44.6804 53.6664 43.9136C53.6664 43.1468 53.0448 42.5252 52.278 42.5252C51.5112 42.5252 50.8896 43.1468 50.8896 43.9136C50.8896 44.6804 51.5112 45.3019 52.278 45.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2865 98.7972C36.4912 98.7972 21.6426 93.4674 19.4259 83.6884C18.2386 78.4505 19.6291 71.4434 21.5971 67.4491C28.6364 53.1584 43.0625 50.0459 52.2865 50.0459C61.5104 50.0459 75.9365 53.1597 82.9758 67.4491C84.9438 71.4434 86.3329 78.4518 85.147 83.6884C82.9303 93.4674 68.0817 98.7972 52.2865 98.7972Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2868 96.8101C37.7804 96.8101 24.1418 91.9153 22.1055 82.9331C21.0159 78.1221 22.2927 71.6856 24.099 68.0172C30.5647 54.8916 43.8143 52.0319 52.2855 52.0319C60.7566 52.0319 74.0076 54.8916 80.4719 68.0172C82.2795 71.6856 83.5564 78.1221 82.4654 82.9331C80.4318 91.9153 66.7945 96.8101 52.2868 96.8101Z",
    fill: "#060C23"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1717 81.0118C36.168 80.0082 34.3621 80.0082 33.3584 81.0119C32.9746 81.3957 32.3523 81.3957 31.9685 81.0118C31.5847 80.628 31.5847 80.0057 31.9685 79.6219C33.7398 77.8506 36.7903 77.8506 38.5616 79.6219C38.9454 80.0057 38.9454 80.628 38.5616 81.0118C38.1778 81.3957 37.5555 81.3957 37.1717 81.0118Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7806 81.0118C68.7769 80.0082 66.971 80.0082 65.9673 81.0119C65.5835 81.3957 64.9612 81.3957 64.5774 81.0118C64.1936 80.628 64.1936 80.0057 64.5774 79.6219C66.3487 77.8506 69.3991 77.8506 71.1705 79.6219C71.5543 80.0057 71.5543 80.628 71.1705 81.0118C70.7867 81.3957 70.1644 81.3957 69.7806 81.0118Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.774 79.531C88.3906 79.3551 89.0336 79.7107 89.21 80.3252C89.676 81.9478 89.7581 84.2115 89.5385 86.2908C89.4274 87.3432 89.2353 88.3869 88.9571 89.3168C88.6837 90.231 88.3051 91.1108 87.7801 91.7756C87.3834 92.2779 86.6532 92.3646 86.1492 91.9693C85.6452 91.574 85.5582 90.8464 85.9548 90.3441C86.2235 90.0039 86.4977 89.4364 86.7312 88.6556C86.96 87.8907 87.129 86.9917 87.2286 86.0486C87.4304 84.1368 87.3318 82.1974 86.977 80.9621C86.8005 80.3476 87.1573 79.7069 87.774 79.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0686 95.6051C84.7313 95.6051 85.2685 95.0706 85.2685 94.4113C85.2685 93.752 84.7313 93.2175 84.0686 93.2175C83.4059 93.2175 82.8687 93.752 82.8687 94.4113C82.8687 95.0706 83.4059 95.6051 84.0686 95.6051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5568 86.3946C47.1118 85.8406 48.0124 85.8398 48.5683 86.3929C50.62 88.4341 53.949 88.4341 56.0007 86.3929C56.5566 85.8398 57.4572 85.8406 58.0122 86.3946C58.5671 86.9486 58.5664 87.8461 58.0104 88.3991C54.8482 91.5451 49.7208 91.5451 46.5586 88.3991C46.0026 87.8461 46.0019 86.9486 46.5568 86.3946Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.751 88.246V87.3872C33.751 87.2526 33.8595 87.1446 33.9948 87.1446H34.858C34.9933 87.1446 35.1019 87.2526 35.1019 87.3872V88.246C35.1019 88.3805 34.9933 88.4886 34.858 88.4886H33.9948C33.8613 88.4886 33.751 88.3805 33.751 88.246Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.877 88.2467V87.3879C31.877 87.2533 31.9855 87.1453 32.1208 87.1453H32.984C33.1193 87.1453 33.2278 87.2533 33.2278 87.3879V88.2467C33.2278 88.3812 33.1193 88.4893 32.984 88.4893H32.1208C31.9855 88.4893 31.877 88.3812 31.877 88.2467Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2017 88.246V87.3872C72.2017 87.2526 72.3102 87.1446 72.4455 87.1446H73.3087C73.444 87.1446 73.5526 87.2526 73.5526 87.3872V88.246C73.5526 88.3805 73.444 88.4886 73.3087 88.4886H72.4455C72.3102 88.4886 72.2017 88.3805 72.2017 88.246Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3521 88.2467V87.3879C70.3521 87.2533 70.4606 87.1453 70.5959 87.1453H71.4591C71.5944 87.1453 71.7029 87.2533 71.7029 87.3879V88.2467C71.7029 88.3812 71.5944 88.4893 71.4591 88.4893H70.5959C70.4624 88.4893 70.3521 88.3812 70.3521 88.2467Z",
    fill: "#FF5555"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2778 43.6206V28.7531",
    stroke: "white",
    strokeWidth: 0.693381
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.67084,
    cy: 3.67084,
    r: 3.67084,
    transform: "matrix(1 0 0 -1 48.6074 33.3841)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29834 34.7641C6.95609 41.1087 6.10491 47.6394 6.56766 53.9718M7.37582 59.8132C7.78213 61.7983 8.31866 63.7505 8.97953 65.6571C9.47084 67.0745 10.0309 68.4666 10.6572 69.8282",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.35 34.9258C99.5543 42.8504 100.513 51.5835 99.0305 60.0817",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_29003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemobot);
export default __webpack_public_path__ + "static/media/demo bot.e370e5c23a8cc8d361298fde32d09ec7.svg";
export { ForwardRef as ReactComponent };